import React, { useMemo } from 'react';
import shortid from 'shortid';
import { ACTIONABLE_BUTTON } from '../formats';
import CopyButton from '../utils/CopyButton';
import { parseTypeArrayOrObjectADRToCopy } from '../utils/parseADRToCopyUtils';
import DefaultFormatActionableButton from './DefaultFormatActionableButton';
import DefaultRootBody from './DefaultRootBody';
import DefaultRootHeader from './DefaultRootHeader';

const DefaultTypeObject = props => {
  // eslint-disable-next-line no-unused-vars
  const {
    children,
    schema,
    path = [],
    root: isRoot,
    isChildRoot,
    enableCopyField,
    customCopyFieldComponent,
  } = props;
  const { $schema: isSchema, title, description, format } = schema;

  /* Don't show the copy button for a section without a title until we can
  highlight the entire section in the UI, otherwise it looks confusing
  */
  const showCopyButton = useMemo(() => !!title, [title]);

  const copyableText = parseTypeArrayOrObjectADRToCopy(
    schema,
    props.ownData,
    false,
    path,
  );

  if (isSchema) {
    return (
      <div
        className={`${
          isSchema && !isChildRoot
            ? 'default-type-root'
            : isSchema && isChildRoot
              ? 'default-type-object is-child-root'
              : 'default-type-object'
        } depth-${path.length}`}
      >
        <DefaultRootHeader
          title={title}
          description={description}
          isChildRoot={isChildRoot}
        />
        <DefaultRootBody children={children} />
      </div>
    );
  }
  return (
    <div className={`default-type-object depth-${path.length}`}>
      <div className="default-type-object-title">
        {(title || description) && (
          <>
            <strong className="default-type-title">{title}</strong>
            {description && (
              <div className="default-type-description">{description}</div>
            )}
          </>
        )}
        {showCopyButton && enableCopyField && (
          <CopyButton
            key={shortid.generate()}
            text={copyableText}
            customButton={customCopyFieldComponent}
          />
        )}
      </div>

      {format && format === ACTIONABLE_BUTTON && (
        <DefaultFormatActionableButton {...props} />
      )}
      <div className="default-type-object-children">{children}</div>
    </div>
  );
};

export default DefaultTypeObject;
